import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { ClockRotateLeft } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

export const ChangesItemMenuContent: React.FC = () => (
  <DropdownMenu.Button id="restore" title="Restore" icon={ClockRotateLeft} />
)
